<h2 mat-dialog-title>
  Excluir a etapa "{{ data.nomeEtapa }}"?
  <span class="status-badge badge-cinza">{{ data.nomeProcesso }}</span>
</h2>
<mat-dialog-content>
  <p class="descricao-modal">
    Documentos nesta etapa impedem a exclusão.
    @if (data.qtdMovimentacoesApontando > 0) {
    {{ data.qtdMovimentacoesApontando }} movimentação(ões) apontam para esta etapa e serão removidas.
    }
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()">Excluir</button>
</mat-dialog-actions>